//1. This Leafet map with key

// import React, { useEffect, useState, useContext } from 'react';
// import {
//   MapContainer,
//   TileLayer,
//   Marker,
//   Popup
// } from 'react-leaflet';
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css';
// import { BusinessApi } from '../../../../../api/Api';
// import { AppThemeContext } from '../../../../../context/AppThemeContext';

// // Fix for missing marker icons
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
// });

// const center = [27.0, 80.0];

// export default function BusinessLocationLeaflet() {
//   const { PrimaryColor } = useContext(AppThemeContext);
//   const [logData, setLogData] = useState([]);

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LOGIN_ID") || "",
//     SS_KEY: localStorage.getItem("SS_KEY")
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await BusinessApi(credentials);
//         if (res?.data && Array.isArray(res.data)) {
//           setLogData(res.data);
//         }
//       } catch (err) {
//         console.error("Error fetching data:", err);
//       }
//     };

//     fetchData();
//   }, [credentials.LOGIN_ID]);

//   return (
//     <MapContainer center={center} zoom={5} style={{ height: '100vh', width: '100%' }}>
//       <TileLayer
//         url="https://api.maptiler.com/maps/basic/256/{z}/{x}/{y}.png?key=YOUR_KEY"
//         attribution='<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
//       />

//       {logData
//         .filter((data) => data.LATITUDE && data.LONGITUDE)
//         .map((location, index) => (
//           <Marker
//             key={index}
//             position={[parseFloat(location.LATITUDE), parseFloat(location.LONGITUDE)]}
//           >
//             <Popup>
//               <strong>{location.user}</strong><br />
//               <strong>Plant Location:</strong> {location.PLANT_LOCATION}<br />
//               <strong>Status:</strong> {location.STATUS}<br />
//               <strong>Current KW:</strong> {location.LKW}<br />
//               <strong>Plant Capacity:</strong> {location.Plant_capacity}<br />
//               <strong>Total KWH:</strong> {location.TOTAL_KWH}
//             </Popup>
//           </Marker>
//         ))}
//     </MapContainer>
//   );
// }


//3. google map react

// import React, { useContext, useEffect, useState } from "react";
// import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
// import { BusinessApi, InverterDetail } from "../../../../../api/Api";
// import { AppThemeContext } from "../../../../../context/AppThemeContext";

// function BusinessLocation(props) {
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const [logData, setLogData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);

//     const [credentials] = useState({
//         LOGIN_ID: localStorage.getItem("LOGIN_ID") || "",
//         SS_KEY:localStorage.getItem("SS_KEY")
//     });

//     const fetchLogData = async () => {
//         setLoading(true);
//         setError(null);
//         setLogData([]);
//         try {
//             const res = await BusinessApi(credentials);
//             if (res?.data && Array.isArray(res.data)) {
//                 setLogData(res.data);
//             } else {
//                 setLogData([]);
//             }
//         } catch (err) {
//             console.error("Error fetching data:", err);
//             setError("Failed to fetch data.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchLogData();
//     }, [credentials.LOGIN_ID]);

//     const locations = logData
//         .filter((data) => data.LATITUDE && data.LONGITUDE)
//         .map((data) => ({
//             lat: parseFloat(data.LATITUDE),
//             lng: parseFloat(data.LONGITUDE),
//             label: data.user,
//             PLANT_LOCATION: data.PLANT_LOCATION,
//             status: data.STATUS,
//             Current_KW: data.LKW,
//             Plant_Capacity:data.Plant_capacity,
//             Total_KWH:data.TOTAL_KWH,


//         }));

//     const [activeMarker, setActiveMarker] = useState(null);
//     const [selectedPlace, setSelectedPlace] = useState({});
//     const [showingInfoWindow, setShowingInfoWindow] = useState(false);

//     const onMarkerHover = (props, marker, location) => {
//         setSelectedPlace({
//             name: location.label,
//             PLANT_LOCATION: location.PLANT_LOCATION,
//             status: location.status,
//             Current_KW:location.Current_KW,
//             Plant_Capacity:location.Plant_Capacity,
//             Total_KWH:location.Total_KWH
//         });
//         setActiveMarker(marker);
//         setShowingInfoWindow(true);
//     };

//     const onInfoWindowClose = () => {
//         setActiveMarker(null);
//         setShowingInfoWindow(false);
//     };

//     const style = {
//         maxWidth: "85vw",
//         height: "80vh",
//         overflowX: "hidden",
//         overflowY: "hidden",
//         border:  `4px solid ${PrimaryColor}`,
//         borderRadius: "4px",

//     };

//     return (

//         <div className="row"   style={{ height: "500px", width: "100%", overflow: "hidden" }}>
//             <div className="col-md-12">
//                 <div style={{ height: "500px", width: "100%", overflow: "hidden" }}>
//                     <Map google={props.google} zoom={5} initialCenter={{ lat: 27.0, lng: 80.0 }} style={style} >
//                         {locations.map((location, index) => {
//                             const markerIcon =
//                                 location.status === "Offline"
//                                     ? { url: `http://maps.google.com/mapfiles/ms/icons/red-dot.png` }
//                                     : { url: `http://maps.google.com/mapfiles/ms/icons/green-dot.png` };

//                             return (
//                                 <Marker
//                                     key={index}
//                                     position={{ lat: location.lat, lng: location.lng }}
//                                     name={location.label}
//                                     onMouseover={(props, marker) => onMarkerHover(props, marker, location)}
//                                     icon={markerIcon}
//                                 />
//                             );
//                         })}

//                         <InfoWindow marker={activeMarker} visible={showingInfoWindow} onClose={onInfoWindowClose}>
//                             <div>
//                                 <h4>{selectedPlace.name}</h4>
//                                 <p><strong>Plant Location:</strong> {selectedPlace.PLANT_LOCATION}</p>
//                                 <p><strong>Status:</strong> {selectedPlace.status}</p>
//                                 <p><strong>Current KW:</strong> {selectedPlace.Current_KW}</p>
//                                 <p><strong>Plant Capacity:</strong> {selectedPlace.Plant_Capacity}</p>
//                                 <p><strong>Total KWH:</strong> {selectedPlace.Total_KWH}</p>

//                             </div>
//                         </InfoWindow>
//                     </Map>
//                 </div>
//             </div>
//         </div>

//     );
// }

// export default GoogleApiWrapper({
//     apiKey: "AIzaSyBoA0HlBswePv6ZmOewvoJK49FfIdd1PyI",
// })(BusinessLocation);


//3. This leafet map without Key

// import React, { useEffect, useState, useContext } from 'react';
// import {
//     MapContainer,
//     TileLayer,
//     Marker,
//     Popup
// } from 'react-leaflet';
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css';
// import { BusinessApi } from '../../../../../api/Api';
// import { AppThemeContext } from '../../../../../context/AppThemeContext';

// // Default center
// const center = [27.0, 80.0];

// // Custom marker icons
// const redIcon = new L.Icon({
//     iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
//     shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
//     iconSize: [25, 41],
//     iconAnchor: [12, 41],
//     popupAnchor: [1, -34],
//     shadowSize: [41, 41]
// });

// const greenIcon = new L.Icon({
//     iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png',
//     shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
//     iconSize: [25, 41],
//     iconAnchor: [12, 41],
//     popupAnchor: [1, -34],
//     shadowSize: [41, 41]
// });

// export default function BusinessLocationLeaflet() {
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const [logData, setLogData] = useState([]);

//     const credentials = {
//         LOGIN_ID: localStorage.getItem("LOGIN_ID") || "",
//         SS_KEY: localStorage.getItem("SS_KEY")
//     };

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const res = await BusinessApi(credentials);
//                 if (res?.data && Array.isArray(res.data)) {
//                     setLogData(res.data);
//                 }
//             } catch (err) {
//                 console.error("Error fetching data:", err);
//             }
//         };

//         fetchData();
//     }, [credentials.LOGIN_ID]);

//     return (
//         <MapContainer center={center} zoom={5} style={{ height: '100vh', width: '100%' }}>
//             <TileLayer
//                 url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//                 attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//             />

//             {logData
//                 .filter((data) => data.LATITUDE && data.LONGITUDE)
//                 .map((location, index) => {
//                     const markerIcon = location.STATUS?.toLowerCase() === 'online' ? greenIcon : redIcon;
//                     return (
//                         <Marker
//                             key={index}
//                             position={[parseFloat(location.LATITUDE), parseFloat(location.LONGITUDE)]}
//                             icon={markerIcon}
//                         >
//                             <Popup>
//                                 <strong>{location.user}</strong><br />
//                                 <strong>Plant Location:</strong> {location.PLANT_LOCATION}<br />
//                                 <strong>Status:</strong> {location.STATUS}<br />
//                                 <strong>Current KW:</strong> {location.LKW}<br />
//                                 <strong>Plant Capacity:</strong> {location.Plant_capacity}<br />
//                                 <strong>Total KWH:</strong> {location.TOTAL_KWH}
//                             </Popup>
//                         </Marker>
//                     );
//                 })}
//         </MapContainer>
//     );
// }

// 4.jo map show ho raha tha 

import React, { useEffect, useState, useContext } from 'react';
import {
    MapContainer,
    TileLayer,
    Marker,
    Popup,
    Tooltip
} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { BusinessApi } from '../../../../../api/Api';
import "./BusinessLocation.css"
import { AppThemeContext } from '../../../../../context/AppThemeContext';
import { padding } from '@mui/system';
import { AuthenticationContext } from '../../../../../context/AuthenticationContext';
import { APP_KEY } from "../../../../../api/AxiosApi";
import { Link, useNavigate } from 'react-router-dom';
import TopHeaderBusiness from "../../../../../components/general/TopHeaderBusiness";

const center = [27.0, 80.0];

const redIcon = new L.Icon({
    className:"blink",
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

const greenIcon = new L.Icon({
    className:"blink",
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

export default function BusinessLocation() {
    const { PrimaryColor } = useContext(AppThemeContext);
    const [logData, setLogData] = useState([]);
    const { userLogin } = useContext(AuthenticationContext);

    const credentials = {
        LOGIN_ID: localStorage.getItem("business_LOGIN_ID") || "",
        SS_KEY: localStorage.getItem("business_SS_KEY")
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await BusinessApi(credentials);
                if (res?.data && Array.isArray(res.data)) {
                    setLogData(res.data);
                }
            } catch (err) {
                console.error("Error fetching data:", err);
            }
        };

        fetchData();
    }, [credentials.LOGIN_ID]);

    const handleLoginClick = (LOGIN_NAME, PW, USER_TYPE) => {
        localStorage.setItem("pass", "target");
        userLogin(LOGIN_NAME, PW, APP_KEY);
    };

    return (

        <>
         <TopHeaderBusiness/>
         <MapContainer center={center} zoom={5} style={{ height: '80%', width: '99%',marginTop:".8rem" }}>
            <TileLayer
                url="https://api.maptiler.com/maps/basic-v2/256/{z}/{x}/{y}.png?key=wqBRkwqr9CEgeNgas9mP"
                attribution='&copy; <a href="https://www.maptiler.com/copyright/">MapTiler</a> & <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />


            {logData
                .filter((data) => data.LATITUDE && data.LONGITUDE)
                .map((location, index) => {
                    const markerIcon = location.STATUS?.toLowerCase() === 'online' ? greenIcon : redIcon;
                    return (
                        <Marker
                            key={index}
                            position={[parseFloat(location.LATITUDE), parseFloat(location.LONGITUDE)]}
                            icon={markerIcon}
                        >
                            <Tooltip direction="top" offset={[0, -20]} opacity={1}>
                                <div className="tooltip-class">
                                    <strong><h6>
                                        <Link
                                            // href="#"
                                            to=""
                                            // target="_blank"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                handleLoginClick(location.USER_ID, location.PASSWORD, location.USER_TYPE); // Call the function to login
                                                window.open("/userDashboard", "_blank", "noopener,noreferrer");
                                            }}
                                            style={{ textDecoration: "none", color: "#007BFF" }}

                                        >
                                            {location.user}
                                        </Link>
                                    </h6></strong>
                                    <strong style={{ fontSize: "15px", color: "#007BFF" }}>Plant Capacity:</strong><span style={{ fontSize: "15px", color: "#007BFF" }}>{location.Plant_capacity}</span> <br />
                                    <strong>Plant Location:</strong> {location.PLANT_LOCATION}<br />
                                    <strong>Total KWH:</strong> {location.TOTAL_KWH}
                                    <strong>Current KW:</strong> {location.LKW}<br />
                                    <strong>Status:</strong>
                                    <span
                                        className='blink'
                                        style={{
                                            color:
                                                location.STATUS?.toLowerCase() === 'online'
                                                    ? 'green'
                                                    : location.STATUS?.toLowerCase() === 'offline'
                                                        ? 'red'
                                                        : 'orange' // optional fallback
                                        }}
                                    >
                                        {location.STATUS}
                                    </span>
                                    <br />

                                    <strong>Alarm:</strong><span className='blink' style={{ color: "orange" }}>{location.ALARM}</span><br />


                                </div>
                            </Tooltip>
                            <Popup>
                                <strong><h6>
                                    <Link
                                        // href="#"
                                        to=""
                                        // target="_blank"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            handleLoginClick(location.USER_ID, location.PASSWORD, location.USER_TYPE); // Call the function to login
                                            window.open("/userDashboard", "_blank", "noopener,noreferrer");
                                        }}
                                        style={{ textDecoration: "none", color: "#007BFF" }}

                                    >
                                        {location.user}
                                    </Link>
                                </h6></strong>
                                <strong style={{ fontSize: "15px", color: "#007BFF" }}>Plant Capacity:</strong><span style={{ fontSize: "15px", color: "#007BFF" }}>{location.Plant_capacity}</span> <br />
                                <strong>Plant Location:</strong> {location.PLANT_LOCATION}<br />
                                <strong>Total KWH:</strong> {location.TOTAL_KWH}<br/>
                                <strong>Current KW:</strong> {location.LKW}<br/>
                                <strong>Status:</strong>
                                <span
                                    className='blink'
                                    style={{
                                        color:
                                            location.STATUS?.toLowerCase() === 'online'
                                                ? 'green'
                                                : location.STATUS?.toLowerCase() === 'offline'
                                                    ? 'red'
                                                    : 'orange' // optional fallback
                                    }}
                                >
                                    {location.STATUS}
                                </span>
                                <br />

                                <strong>Alarm:</strong><span className='blink' style={{ color: "orange" }}>{location.ALARM}</span><br />
                            </Popup>
                        </Marker>
                    );
                })}
        </MapContainer>
        </>
       
    );
}



//5. MapLibreMap.jsx



// import React, { useEffect, useRef } from 'react';
// import maplibregl from 'maplibre-gl';
// import 'maplibre-gl/dist/maplibre-gl.css';

// const BusinessLocation = () => {
//     const mapContainer = useRef(null);
//     const mapRef = useRef(null); // To avoid re-creating controls on re-render

//     useEffect(() => {
//         const map = new maplibregl.Map({
//             container: mapContainer.current,
//             style: 'https://api.maptiler.com/maps/basic-v2/style.json?key=wqBRkwqr9CEgeNgas9mP',
//             center: [78.9629, 20.5937], // Center of India (not just New Delhi)
//             zoom: 5,
//         });

//         mapRef.current = map;

//         // Add marker at New Delhi
//         new maplibregl.Marker()
//             .setLngLat([77.209, 28.6139])
//             .addTo(map);

//         // Add zoom and rotation controls to the right
//         map.addControl(new maplibregl.NavigationControl({ showCompass: true }), 'top-right');

//         return () => map.remove();
//     }, []);

//     return (
//         <div
//             ref={mapContainer}
//             style={{
//                 width: '100%',
//                 height: '800px',
//                 borderRadius: '8px',
//             }}
//         />
//     );
// };

// export default BusinessLocation;
